require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-philippe-le-houerou-just-shook-up-the-accountability-debate.json") })
        }
      }, "path---en-us-update-philippe-le-houerou-just-shook-up-the-accountability-debate");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-philippe-le-houerou-just-shook-up-the-accountability-debate!./.cache/json/en-us-update-philippe-le-houerou-just-shook-up-the-accountability-debate.json
// module id = 784
// module chunks = 231608221292675